
import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
import HeroSection from '../components/Coach/HeroSection';
import TabbedFeaturesSection from '../components/Coach/TabbedFeaturesSection';
import Testimonials from '../components/Coach/Testimonials';
import GuaranteeSection from '../components/Coach/GuaranteeSection';
import StoryAndCTA from '../components/Coach/StoryAndCTA';
import WhyKinosDifferent from '../components/Coach/WhyKinosDifferent';

const AllInOneHome = () => {
  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow">
        <HeroSection />
        <TabbedFeaturesSection />
        <WhyKinosDifferent />
        <GuaranteeSection />
        <Testimonials />
        <StoryAndCTA />
      </main>
      <Footer />
    </div>
  );
};

export default AllInOneHome;